/* Adrena : 12 places par stage (corrige les textes de XP-Bot) */
(function(){
  var R=[[/15 participants/g,'12 participants'],[/15 places/g,'12 places'],[/limitées à 15/g,'limitées à 12']];
  function fix(n){
    if(n.nodeType===3){var t=n.nodeValue,o=t;for(var i=0;i<R.length;i++)t=t.replace(R[i][0],R[i][1]);if(t!==o)n.nodeValue=t;return;}
    if(n.nodeType===1&&n.tagName!=='SCRIPT'&&n.tagName!=='STYLE'){for(var c=n.firstChild;c;c=c.nextSibling)fix(c);}
  }
  function run(){fix(document.body);new MutationObserver(function(m){m.forEach(function(r){r.addedNodes.forEach(fix);if(r.type==='characterData')fix(r.target);});}).observe(document.body,{childList:true,subtree:true,characterData:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
